import React from 'react';
import PropTypes from 'prop-types';
import './UserResources.scss';
import Feed from 'components/Feed';


export default class UserResources extends React.Component {
    constructor (props) {
        super(props);
    }

    render() {

        const multiWayD = [
            {
                title: '3-way Line Load in a different Junction Box',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/thumbnails/resources/Multi-Way+Diagrams/3-way+-+line_load+in+different+jbox.jpg',
                link: 'https://s3.us-west-2.amazonaws.com/com-noonhome-pro/Multi-Way%20Diagrams/3-way%20-%20line_load%20in%20different%20jbox.pdf',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: '3-way Line Load in the same Junction Box',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/thumbnails/resources/Multi-Way+Diagrams/3-way+-+line_load+in+same+box.jpg',
                link: 'https://s3.us-west-2.amazonaws.com/com-noonhome-pro/Multi-Way%20Diagrams/3-way%20-%20line_load%20in%20same%20jbox.pdf',
                download: true,
                ctaLable: 'Download',
            },
        ];

        const proPamphlets= [
            {
                title: 'NOON switch user instructions',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/thumbnails/resources/Post-Install+Pamphlets/NOON+switch+instruction+page.jpg',
                link: 'https://s3.us-west-2.amazonaws.com/com-noonhome-pro/Post-Install%20Pamphlets/NOON%20switch%20instruction%20page.pdf',
                download: true,
                ctaLable: 'Download',
            },
        ];
        const proPagers= [
            {
                title: 'NOON Builder handout',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/thumbnails/resources/Pro+One-Pagers/Builder+Handout.jpg',
                link: 'https://s3.us-west-2.amazonaws.com/com-noonhome-pro/Pro%20One-Pagers/Builder%20Handout.pdf',
                download: true,
                ctaLable: 'Download',
            },
        ];
        const proDocs= [
            {
                title: 'CSI Construct Connect Spec-Data',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/thumbnails/resources/Specification+Documents/CSI.jpg',
                link: 'https://s3.us-west-2.amazonaws.com/com-noonhome-pro/Specification%20Documents/CSI.pdf',
                download: true,
                ctaLable: 'Download',
            },
        ];



        return(
            <section className='resources--container'>
                <h1>Resources</h1>
                <h6 className='r-section-titles'>Multi-Way Diagrams</h6>
                <Feed proFeeds={multiWayD}/>
                <h6>Post-Install Pamphlets</h6>
                <Feed proFeeds={proPamphlets}/>
                <h6>Pro One-Pagers</h6>
                <Feed proFeeds={proPagers}/>
                <h6>Specification Documents</h6>
                <Feed proFeeds={proDocs}/>
            </section>
        )
    }

}


// WEBPACK FOOTER //
// ./src/routes/UserResources/index.js